<script>
import { mapGetters } from 'vuex'
import { isNonEmptyArray } from '@/helpers/array-helpers'
import baseMixin from '@/mixins/baseMixin'
import dayjs from '@/services/date/index'

export default {
  name: 'ClientGroupOverviewGroupSelector',
  mixins: [baseMixin],
  props: {
    groups: {
      type: Array,
      default: () => [],
    },
    selectedGroup: {
      type: Number,
      default: null,
    },
    loading: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      user: 'auth/currentUser',
    }),
    hasGroups() {
      return isNonEmptyArray(this.groups)
    },
    hasSingleGroup() {
      return this.hasGroups && this.groups.length === 1
    },
    compClientGroupTitle() {
      if (!this.hasGroups) return ''
      return `${this.groups[0].groupName}`
    },
    compTitle() {
      const hour = dayjs().hour()
      const userFirstName = this.user?.firstName
      const START_HOUR_OF_EVENING_INT = 16
      const START_HOUR_OF_AFTERNOON_INT = 11

      if (hour > START_HOUR_OF_EVENING_INT)
        return this.$t('greeting.evening', { userFirstName })
      if (hour > START_HOUR_OF_AFTERNOON_INT)
        return this.$t('greeting.afternoon', { userFirstName })

      return this.$t('greeting.morning', { userFirstName })
    },
  },
  methods: {
    changeGroup(value) {
      this.$emit('updateGroup', value)
    },
  },
}
</script>

<template>
  <div>
    <p class="text-subtitle-1 mb-0">{{ compTitle }}</p>
    <v-select
      v-if="selectedGroup && !hasSingleGroup"
      data-testid="client-group-overview-selector"
      item-text="groupName"
      item-value="groupId"
      class="mt-0 pt-0"
      style="width: fit-content"
      :loading="loading"
      :disabled="loading"
      :items="groups"
      :value="selectedGroup"
      @change="changeGroup"
    >
      <template v-slot:selection="{ item }">
        <h5 class="text-h5 font-weight-medium">
          {{
            $t('clientGroupOverview.groupSelector.selectedText', [
              item.groupName,
            ])
          }}
        </h5>
      </template>
    </v-select>
    <h5
      v-else-if="hasSingleGroup"
      class="text-h5 font-weight-medium"
      data-testid="client-group-overview-selector-single"
    >
      {{
        $t('clientGroupOverview.groupSelector.selectedText', [
          compClientGroupTitle,
        ])
      }}
    </h5>
  </div>
</template>
